export default __webpack_public_path__ + "static/media/epizootic_ulcerative_syndrome.35e9ec9b.jpg";